export const appVersionCopy = {
  message: "Há uma nova versão do iLumeConecta disponível.",
  hint: "Atualize a página para usar a versão mais recente.",
  action: "Atualizar agora",
} as const;
